import { render } from "./BottomPanel.vue?vue&type=template&id=9c3a33f0&scoped=true"
import script from "./BottomPanel.vue?vue&type=script&lang=js"
export * from "./BottomPanel.vue?vue&type=script&lang=js"

import "./BottomPanel.vue?vue&type=style&index=0&id=9c3a33f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c3a33f0"]])

export default __exports__